module.exports = __webpack_public_path__ + "Roboto-BlackItalic.3a99796b2d8592471fcf.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.woff
// module id = 103
// module chunks = 17